import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import CrewMember from './CrewMember';
import Icon from '../common/Icon';
import UserSelect from '../common/UserSelect';

const CrewManagement = ({
	channel,
	episode,
	manageCrew,
	role,
}) => {
	const { t } = useTranslation();

	const crews = React.useMemo(() =>
		(episode.crew || [])
		.filter(c => c.channel_id === channel.id && c.role === role)
	, [channel, episode, role]);

	const addCrew = React.useCallback(user_id => {
		manageCrew({
			add: user_id,
			channel_id: channel.id,
			episode_id: episode.id,
			role,
		});
	}, [channel, episode, manageCrew, role]);

	const confirmCrew = React.useCallback(crew => {
		manageCrew({
			channel_id: channel.id,
			confirm: crew.id,
			episode_id: episode.id,
			role,
		});
	}, [channel, episode, manageCrew, role]);

	const removeCrew = React.useCallback(crew => {
		manageCrew({
			channel_id: channel.id,
			episode_id: episode.id,
			remove: crew.id,
			role,
		});
	}, [channel, episode, manageCrew, role]);

	const unconfirmCrew = React.useCallback(crew => {
		manageCrew({
			channel_id: channel.id,
			episode_id: episode.id,
			role,
			unconfirm: crew.id,
		});
	}, [channel, episode, manageCrew, role]);

	return <div className="mt-2">
		<div className="fs-4">{t(`crew.roles.${role}`)}</div>
		{crews.map(crew =>
			<div className="d-flex align-items-center justify-content-between" key={crew.id}>
				<CrewMember crew={crew} />
				<div className="button-bar">
					{crew.confirmed ?
						<Button
							onClick={() => unconfirmCrew(crew)}
							title={t('button.unconfirm')}
							variant="outline-danger"
						>
							<Icon.REJECT title="" />
						</Button>
					: null}
					{!crew.confirmed ?
						<Button
							onClick={() => confirmCrew(crew)}
							title={t('button.confirm')}
							variant="outline-success"
						>
							<Icon.ACCEPT />
						</Button>
					: null}
					<Button
						onClick={() => removeCrew(crew)}
						title={t('button.remove')}
						variant="outline-danger"
					>
						<Icon.DELETE title="" />
					</Button>
				</div>
			</div>
		)}
		<Form.Group controlId="crew.addUser">
			<Form.Label>{t('episodes.restreamDialog.addUser')}</Form.Label>
			<Form.Control
				as={UserSelect}
				onChange={e => addCrew(e.target.value)}
				value=""
			/>
		</Form.Group>
	</div>;
};

CrewManagement.propTypes = {
	channel: PropTypes.shape({
		id: PropTypes.number,
	}),
	episode: PropTypes.shape({
		crew: PropTypes.arrayOf(PropTypes.shape({
			channel_id: PropTypes.number,
			role: PropTypes.string,
		})),
		id: PropTypes.number,
	}),
	manageCrew: PropTypes.func,
	role: PropTypes.string,
};

export default CrewManagement;
